module.exports = __webpack_public_path__ + "img/iphone69_screenshot-4.35b528fe.jpeg";